/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/Skeleton/theme';

export const SkeletonTheme = theme;
